export enum EditorSaveStatusType {
  IDLE = 'idle',
  DIRTY = 'dirty',
  SAVING = 'saving',
  SAVED = 'saved',
  ERROR = 'error',
  CONFLICT = 'conflict',
  CONNECTION_LOST = 'connection-lost',
}

export enum FormatProperty {
  STRONG = 'strongActive',
  EM = 'emActive',
  BULLET_LIST = 'bulletListActive',
  ORDERED_LIST = 'orderedListActive',
}

export interface EditorFormatState {
  [FormatProperty.STRONG]: boolean
  [FormatProperty.EM]: boolean
  [FormatProperty.BULLET_LIST]: boolean
  [FormatProperty.ORDERED_LIST]: boolean
}

export enum TextSizeLabel {
  NORMAL_TEXT = 'Normal Text',
  HEADING_1 = 'Heading 1',
  HEADING_2 = 'Heading 2',
  HEADING_3 = 'Heading 3',
}
